module.exports = __webpack_public_path__ + "img/4_109.5569ab4f.png";